import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/landing/Logo";
import { API, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory px-6" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <div className="w-full max-w-md border border-line bg-white p-10 sm:p-12">
        <div className="text-ink">
          <Logo markClass="h-10 w-auto" />
        </div>
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-terracotta">Area Riservata</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#8A8D8B]">Email</label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-line bg-ivory/50 transition-colors focus-visible:ring-1 focus-visible:ring-terracotta"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#8A8D8B]">Password</label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-line bg-ivory/50 transition-colors focus-visible:ring-1 focus-visible:ring-terracotta"
              data-testid="admin-password-input"
            />
          </div>
          {error && (
            <p className="border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full bg-ink py-4 text-[11px] font-semibold uppercase tracking-[0.24em] text-ivory transition-colors duration-500 hover:bg-terracotta disabled:opacity-50"
          >
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
        <a href="/" className="mt-8 block text-center text-xs text-[#8A8D8B] transition-colors hover:text-terracotta" data-testid="back-to-site-link">
          ← Torna al sito
        </a>
      </div>
    </div>
  );
}
